import React from "react";
import "./Dealer.scss";
import { useSelector } from "react-redux";
import { Box, Button } from "@mui/material";
import HelpText, { getHelpText } from "../HelpText/HelpText";
import Autocomplete from "@mui/material/Autocomplete";
import { createFilterOptions } from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Grid from "@mui/material/Grid";

const Dealer = (props) => {
  const dealerList =
    useSelector((state) => state.validation.validations.dealers) || [];
  const dealerPref =
    useSelector((state) => state.auth.vtr_preferences.dealer) || [];
  let dealerPrefArray = [];
  if (dealerPref && Array.isArray(dealerPref) && dealerPref.length > 0) {
    for (let e = 0; e < dealerPref.length; e++) {
      for (let f = 0; f < dealerList.length; f++) {
        if (dealerPref[e] === dealerList[f].DEALER_PERMIT_NUMBER) {
          dealerPrefArray[dealerPrefArray.length] = dealerList[f];
          break;
        }
      }
    }
  }
  const selectedValue = {
    DEALER_PERMIT_NUMBER: props.dealer_permit_number,
    DEALER_NAME: props.dealer_name,
  };

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    ignoreCase: true,
    trim: true,
    stringify: (option) =>
      option.DEALER_PERMIT_NUMBER + " " + option.DEALER_NAME,
  });

  return (
    <div className="Dealer" data-testid="Dealer" key={"dealer_box_div"}>
      <Box mt={0} width="100%" align="center" key={"dealer_box"}>
        <h2 className="sectionTitle center">Dealer</h2>
        <Grid
          container
          spacing={2}
          justifyContent="center"
          alignItems="center"
          key={"dealer_box_grid"}
          direction="column"
        >
          <Grid item xs={12} md="auto" key={"dealer_box_grid_item"}>
            <Box
              display="flex"
              flexWrap="wrap"
              justifyContent="center"
              key={"dealer_pref_box"}
            >
              {dealerPrefArray.map((dealer) => (
                <Box m={0.5} key={"dealer_box_" + dealer.DEALER_PERMIT_NUMBER}>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    className="form-input"
                    data-dealer_permit_number={dealer.DEALER_PERMIT_NUMBER}
                    data-dealer_name={dealer.DEALER_NAME}
                    size="large"
                    onClick={(e) =>
                      props.handleDealerPreferenceChange(
                        e,
                        dealer.DEALER_PERMIT_NUMBER
                      )
                    }
                    key={dealer.DEALER_PERMIT_NUMBER}
                  >
                    {dealer.DEALER_PERMIT_NUMBER + " - " + dealer.DEALER_NAME}
                  </Button>
                </Box>
              ))}
            </Box>
          </Grid>
        </Grid>
        <Box display="flex" justifyContent="center">
          <Box>
            <Autocomplete
              id="dealer_auto_complete"
              key={"dealer_auto"}
              options={dealerList}
              getOptionLabel={(option) =>
                option.DEALER_PERMIT_NUMBER
                  ? option.DEALER_PERMIT_NUMBER + " - " + option.DEALER_NAME
                  : ""
              }
              style={{ maxWidth: 350, minWidth: 300 }}
              onChange={props.changeHandler}
              value={selectedValue}
              name={"dealer"}
              isOptionEqualToValue={(option) => option.DEALER_PERMIT_NUMBER}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Dealer"
                  variant="standard"
                  helperText={getHelpText(props.helpText, "dealer")}
                />
              )}
              filterOptions={filterOptions}
            />
          </Box>
          <Box>
            <HelpText helpText={getHelpText(props.helpText, "dealer")} />
          </Box>
        </Box>
      </Box>
    </div>
  );
};

export default Dealer;
